import gql from 'graphql-tag';
import createQuery from './createQuery';

export default createQuery(gql`
  query getBasicAuthKeys ($token:String!) {
    getBasicAuthKeys(token: $token)
  }
`);
